/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AzureVmInstanceRestoreDestination } from '../models/AzureVmInstanceRestoreDestination';

export class RestoreAzureVmInstanceRequest {
  /**
  * Eon-assigned ID of the restore account.
  */
  'restoreAccountId': string;
  'destination': AzureVmInstanceRestoreDestination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "destination",
      "baseName": "destination",
      "type": "AzureVmInstanceRestoreDestination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreAzureVmInstanceRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

